import { Label, Slider, Checkbox } from '@creanizer/ui'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@creanizer/ui'
import type { DungeonInput } from '@creanizer/types'

interface DungeonFormCommonProps {
  input: DungeonInput
  onChange: (input: DungeonInput) => void
  useStreaming?: boolean
  onStreamingChange?: (value: boolean) => void
}

export function DungeonFormCommon({ input, onChange, useStreaming, onStreamingChange }: DungeonFormCommonProps) {
  return (
    <div className="space-y-4">
      {/* 難易度 - 全モード共通 */}
      <div>
        <Label htmlFor="difficulty">難易度</Label>
        <Select
          value={input.difficulty || 'normal'}
          onValueChange={(value) => onChange({ ...input, difficulty: value as DungeonInput['difficulty'] })}
        >
          <SelectTrigger>
            <SelectValue placeholder="難易度を選択" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="easy">イージー</SelectItem>
            <SelectItem value="normal">ノーマル</SelectItem>
            <SelectItem value="hard">ハード</SelectItem>
            <SelectItem value="extreme">エクストリーム</SelectItem>
            <SelectItem value="custom">カスタム</SelectItem>
          </SelectContent>
        </Select>
      </div>

      {/* 創造性レベル */}
      <div>
        <Label htmlFor="creativityLevel">創造性レベル: {input.creativityLevel || 7}/10</Label>
        <Slider
          id="creativityLevel"
          min={1}
          max={10}
          step={1}
          value={[input.creativityLevel || 7]}
          onValueChange={([value]) => onChange({ ...input, creativityLevel: value })}
        />
        <div className="flex justify-between text-xs text-muted-foreground mt-1">
          <span>一般的</span>
          <span>バランス</span>
          <span>独創的</span>
        </div>
      </div>

      {/* プロモード */}
      <div className="flex items-center space-x-2">
        <Checkbox
          id="useProMode"
          checked={input.useProMode || false}
          onCheckedChange={(checked) => onChange({ ...input, useProMode: checked as boolean })}
        />
        <Label htmlFor="useProMode" className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
          Proモードを使用（より詳細で高品質な生成）
        </Label>
      </div>

      {/* Gemini 3 Flash モード */}
      <div className="flex items-center space-x-2">
        <Checkbox
          id="useGemini3FlashMode"
          checked={input.useGemini3FlashMode || false}
          onCheckedChange={(checked) => onChange({ ...input, useGemini3FlashMode: checked as boolean })}
        />
        <Label htmlFor="useGemini3FlashMode" className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
          Gemini 3 Flash モード（試験版）
        </Label>
      </div>

      {/* ストリーミングモード */}
      {onStreamingChange && (
        <div className="flex items-center space-x-2">
          <Checkbox
            id="useStreaming"
            checked={useStreaming || false}
            onCheckedChange={(checked) => onStreamingChange(checked as boolean)}
          />
          <Label htmlFor="useStreaming" className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
            ストリーミングを使用（リアルタイム生成・進捗表示）
          </Label>
        </div>
      )}
    </div>
  )
}